import React from "react";
import { Outlet } from "react-router-dom";
import DashboardLayout from "../../components/layout/DashboardLayout";
import BRAND from "../../brand";

const NAV = [
  { to: "/admin",           label: "Dashboard",    icon: "⬛", end: true },
  { to: "/admin/zones",     label: "Zones & Stations", icon: "🗂️" },
  { to: "/admin/queue-override", label: "Queue Override", icon: "🔀" },
  { to: "/admin/insurance", label: "Insurance / Prefixes", icon: "🏷️" },
  { to: "/admin/staff",     label: "Staff",        icon: "👤" },
  { to: "/admin/settings",  label: "Settings",     icon: "⚙️" },
  { to: "/admin/display",   label: "Display Board", icon: "📺" },
  { to: "/admin/faq",       label: "FAQ / Messages", icon: "💬" },
  { to: "/admin/audio",     label: "Audio",        icon: "🔊" },
  { to: "/admin/reports",   label: "Reports",      icon: "📊" },
];

export default function FacilityAdminLayout() {
  return (
    <DashboardLayout navItems={BRAND.messaging ? NAV : NAV.filter((n) => n.to !== "/admin/faq")} sectionLabel="Facility Admin">
      <Outlet />
    </DashboardLayout>
  );
}
